import { lenis, header, prefersReducedMotion } from '../lenis'

const registrationScrollKey = 'binastra-registration-scroll'

// Defer a hash scroll across a cross-page navigation: stash the target on click,
// then scroll to it once the destination page has loaded.
export function initRegistrationScroll() {
  document.querySelectorAll('[data-register-scroll]').forEach((link) => {
    link.addEventListener('click', (event) => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return

      const destinationUrl = new URL(link.href)
      const isCurrentPage =
        destinationUrl.origin === window.location.origin &&
        destinationUrl.pathname === window.location.pathname &&
        destinationUrl.search === window.location.search

      if (isCurrentPage) return

      event.preventDefault()
      sessionStorage.setItem(registrationScrollKey, destinationUrl.hash.slice(1))
      destinationUrl.hash = ''
      window.location.assign(destinationUrl.href)
    })
  })

  const registrationTargetId = sessionStorage.getItem(registrationScrollKey)

  if (!registrationTargetId) return

  sessionStorage.removeItem(registrationScrollKey)

  const scrollToRegistration = async () => {
    const transition = document.activeViewTransition

    if (transition) await transition.finished.catch(() => {})

    requestAnimationFrame(() => {
      const target = document.getElementById(registrationTargetId)

      if (!target) return

      lenis.scrollTo(target, {
        offset: -(header?.offsetHeight ?? 0),
        duration: prefersReducedMotion.matches ? 0 : 1.2,
        easing: (progress) => 1 - (1 - progress) ** 4,
        immediate: prefersReducedMotion.matches,
      })
    })
  }

  scrollToRegistration()
}
